const AppColors = {
  primary: "#1D9BF0",
  secondary: "#4682b4",
  success: "#3DBE29",
  failed: "#BF3312",
  white: "#fff",
  black: "#0F1419",
  grey: "#536471",
  lightgrey: "#677682",
};

export default AppColors;
